import { translate } from 'shared/helpers/utils'
import { FilterValueComponentType, IColumn } from 'shared/components/filters/Filters.interfaces'
import { IAccessScope, IUser, ShortEntityResponse } from 'reducers/Reducers.interfaces'
import { BulkActionType } from 'shared/components/bulk-actions/BulkActions.interfaces'
import { IAccount } from 'public-pages/enrollment/Enrollment.interfaces'

export function getFilterColumns (accounts: IAccount[], permissions: ShortEntityResponse[], scope: IAccessScope): IColumn[] {
  if (scope === IAccessScope.system) {
    return [
      {
        id: 'first_name',
        name: 'common.form.firstName',
        type: FilterValueComponentType.Input
      },
      {
        id: 'last_name',
        name: 'common.form.lastName',
        type: FilterValueComponentType.Input
      },
      {
        id: 'email',
        name: 'common.form.email',
        type: FilterValueComponentType.Input
      },
      {
        id: 'status',
        name: 'common.status',
        type: FilterValueComponentType.MultipleSelect,
        translateOption: true,
        options: [
          { id: 'ACTIVE', name: 'common.statuses.active' },
          { id: 'PENDING', name: 'common.statuses.pending' },
          { id: 'DELETED', name: 'common.statuses.deleted'},
          { id: 'LOCKED', name: 'common.statuses.locked'}
        ]
      },
      {
        id: 'accountId',
        name: 'common.form.account',
        type: FilterValueComponentType.Select,
        options: accounts
      },
      {
        id: 'permission_ids',
        name: 'common.form.permissions',
        type: FilterValueComponentType.MultipleSelect,
        translateOption: true,
        options: permissions.map(p => ({ id: p.id, name: `permissions.${p.name}` }))
      },
      {
        id: 'accessScope',
        name: 'manageUser.administrators.form.accessScope',
        type: FilterValueComponentType.Select,
        translateOption: true,
        options: [
          {id: IAccessScope.system.toUpperCase(), name: 'manageUser.administrators.form.accessScopes.system'},
          {id: IAccessScope.account.toUpperCase(), name: 'manageUser.administrators.form.accessScopes.account'}
        ]
      }
    ]
  }
  return [
    {
      id: 'first_name',
      name: 'common.form.firstName',
      type: FilterValueComponentType.Input
    },
    {
      id: 'last_name',
      name: 'common.form.lastName',
      type: FilterValueComponentType.Input
    },
    {
      id: 'email',
      name: 'common.form.email',
      type: FilterValueComponentType.Input
    },
    {
      id: 'status',
      name: 'common.status',
      type: FilterValueComponentType.MultipleSelect,
      translateOption: true,
      options: [
        { id: 'ACTIVE', name: 'common.statuses.active' },
        { id: 'PENDING', name: 'common.statuses.pending' },
        { id: 'DELETED', name: 'common.statuses.deleted'},
        { id: 'LOCKED', name: 'common.statuses.locked'}
      ]
    },
    {
      id: 'accountId',
      name: 'common.form.account',
      type: FilterValueComponentType.Select,
      options: accounts
    },
    {
      id: 'permission_ids',
      name: 'common.form.permissions',
      type: FilterValueComponentType.MultipleSelect,
      translateOption: true,
      options: permissions.map(p => ({ id: p.id, name: `permissions.${p.name}` }))
    }
  ]
}

export function getBulkActions () {
  return [
    { name: 'common.form.buttons.deleteBtn', type: BulkActionType.Delete }
  ]
}

export function parsePermissions (permissions: ShortEntityResponse[]): string {
  return permissions.map(p => translate(`permissions.${p.name}`)).join(', ')
}

export function getUserStatus (user: IUser): string {
  if (user.status !== undefined) {
    if (user.status === "PENDING") {
      return 'pending'
    }
    if (user.status === "ACTIVE") {
      return 'active'
    }
    if (user.status === "DELETED") {
      return 'deleted'
    }
    if (user.status === "LOCKED") {
      return 'locked'
    }
    if (user.status === "DISABLED") {
      return 'disabled'
    }
  }
  return user.active  ? (user.pending ? 'pending' : 'active') : 'deleted'
}
